import React, { useState, useEffect, useCallback } from "react";
import { Modal, Form, Select, message } from "antd";

import ProgressSpinner from "../../ProgressSpinner/ProgressSpinner";

import UsersTable from "./UsersTable";
import TextInput from "../../ReusableInputs/TextInput";
import Password from "antd/es/input/Password";
import HeaderTable from "../HeaderTable/HeaderTable";
import { User } from "../../../@types/user";
import userServiceInstance from "../../../APIs/users";

const { Option } = Select;

const ManageMembers: React.FC = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [editingUser, setEditingUser] = useState<User | null>(null);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [isAdding, setIsAdding] = useState<boolean>(false);
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const [form] = Form.useForm();
 
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [role, ] = useState<string>("");
  const [filteredUsers, setFilteredUsers] = useState<User[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRole, setSelectedRole] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 6;
  const [pageNumbers, setPageNumbers] = useState<number[]>([]);

  const fetchUsers = async () => {
    try {
      const result = await userServiceInstance.getAllUsers();
      setUsers(result.data || []);
    } catch (err) {
      console.error("Failed to fetch users:", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleEditClick = (user: User) => {
    setEditingUser(user);
    form.setFieldsValue({
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      role: user.role,
      password: user.password,
    });
    setIsModalVisible(true);
    setIsAdding(false);
  };



  const handleModalCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const handleModalOk = async () => {
    setIsProcessing(true);

    try {
      const userData = {
        email:email,
        Password:Password,
        lastName:lastName,
        firstName:firstName,
        role:role
      }
     
      if (isAdding) {
       
        const result = await userServiceInstance.createNewUser(userData);
        if (result.data) {
          setIsModalVisible(false);
          form.resetFields();
          fetchUsers();
          message.success("User has been successfully added!");
        } else {
          message.error(result.error || "Failed to add user");
        }
      } else {
        if (editingUser) {
          const result = await userServiceInstance.editUser(
            editingUser.id,
            userData
          );
          if (result.data) {
            setIsModalVisible(false);
            form.resetFields();
            fetchUsers();
            message.success("User has been successfully updated!");
          } else {
            message.error(result.error || "Failed to update user");
          }
        }
      }
    } catch (error) {
      console.error("Failed to submit form:", error);
      message.error("Failed to submit form");
    } finally {
      setIsProcessing(false);
    }
  };


  const filterProductsFromSearch = useCallback((users: User[]) => {
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
  
    const tempProducts = users.filter((user) => {
      const productProperties = Object.values(user).map((value) =>
        String(value).toLowerCase()
      );
      return (
        (selectedRole === "all" || user.role === selectedRole) &&
        productProperties.some((property) =>
          property.includes(lowerCaseSearchTerm)
        )
      );
    });
  
    setFilteredUsers(tempProducts);
    setCurrentPage(1);
  }, [searchTerm, selectedRole, setFilteredUsers, setCurrentPage]);

  // const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   setSearchText(e.target.value);
  // };

  // const handleStatusChange = (value: string) => {
  //   setSelectedStatus(value);
  // };

  // const filteredUsers = users.filter((user) => {
  //   return (
  //     (searchText === "" || user.firstName.includes(searchText)) &&
  //     (selectedStatus === "" || user.role === selectedStatus)
  //   );
  // });

 
 


  const handlePageChange = (pageNumber: any) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    if (searchTerm.length > 0) {
      filterProductsFromSearch(users);
    } else {
      setFilteredUsers(users);
    }
  }, [filterProductsFromSearch, searchTerm, users]);

  useEffect(() => {
    filterProductsFromSearch(users);
  }, [filterProductsFromSearch, searchTerm, selectedRole, users]);

  const totalPages = Math.ceil(filteredUsers.length / productsPerPage);
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = filteredUsers.slice(
    indexOfFirstProduct,
    indexOfLastProduct
  );

  const generatePageNumbers = useCallback(() => {
    const numbers = [];
    for (let i = 1; i <= totalPages; i++) {
      numbers.push(i);
    }
    setPageNumbers(numbers);
  }, [totalPages, setPageNumbers]);

  useEffect(() => {
    generatePageNumbers();
  }, [generatePageNumbers, totalPages]);

  const handleSearchTermChange = (e: any) => {
    setSearchTerm(e.target.value);
  };

  const handleRoleChange = (event: any) => {
    setSelectedRole(event.target.value);
  };

  return (
    <div className="p-6">
      <div className="text-center py-2  ">
        <p
          className="mb-[30px] box-border font-semibold text-[rgb(0,34,56)] block  text-[35px]  text-left h-[38px]
       leading-[38.4px] ">
          Members
        </p>
      </div>

      {/* <div className="bg-white p-4 rounded-md w-5/4 mx-auto">
        <p
          className="mb-[10px] box-border 
           text-[rgb(0,34,56)] block  text-[20px]  text-left h-[38px] font semi-bold
       leading-[38.4px] mb-1">
          Manage Members
        </p>

        <button
       onClick={handleAddUserClick}
          className="bg-gray-300 w-[150px] rounded-[10px] text-black font semi-bold "
          disabled={isProcessing}>
          Add New Member
        </button>
      </div> */}

      {/* <div className="flex justify-between mb-4">
        <input
          type="text"
          placeholder="Search user"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="border border-gray-400 p-3 rounded-md w-[250px]
           transition duration-200 focus:outline-none focus:ring-2 
           focus:ring-gray-400 focus:border-transparent shadow-sm 
           hover:shadow-md bg-white placeholder-gray-500"
        />

        <select
          value={selectedStatus}
          onChange={(e) => setSelectedStatus(e.target.value)}
          className="border border-gray-400 p-3 rounded-md w-[250px] transition duration-200 
          focus:outline-none focus:ring-2 focus:ring-gray-400 focus:border-transparent bg-white text-gray-700">
          <option value="">Select User Role</option>
          <option value="client">Client</option>
          <option value="admin">Admin</option>
          <option value="super_admin">Super Admin</option>
        </select>
      </div> */}

      <div className="bg-white p-4 rounded-md w-5/4 mx-auto">

      <HeaderTable
            subtitle="Manage Members"
            // buttonText="Add New Member"
            inputPlaceholder="Search Member"
            selectPlaceholder="Filter By User Type"
            loading={false}
            searchTerm={searchTerm}
            selectedValue={selectedRole}
            // onButtonClick={handleAddProductClick}
            onSearchChange={handleSearchTermChange}
            onSelectChange={handleRoleChange}
            selectOptions={[
              { value: "client", label: "Customers" },
              { value: "admin", label: "Admins" },
              { value: "super_admin", label: "Super Admins" },
              
            ]}
          />

      <UsersTable
        users={filteredUsers}
        loading={loading}
        onEditOrder={handleEditClick}
        // onEditOrder={handleEditProduct}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
            pageNumbers={pageNumbers}
            currentProducts={currentProducts}
           
   
      />

      </div>

      
      <Modal
        title={isAdding ? "Add User" : "Edit User"}
        visible={isModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        width={700}
        height={500}
        footer={null}
        bodyStyle={{ maxHeight: "550px", overflowY: "auto" }}>
        <Form form={form} layout="vertical">
          <section className="flex flex-col md:flex-row md:space-x-4">
            <div className="w-full p-2 text-white">
              <TextInput
                title="First Name"
                placeholder="Enter First Name"
                inputValue={firstName || ""}
                setInputValue={setFirstName}
              />
            </div>
            <div className="w-full p-2 text-white">
              <TextInput
                title="Last Name"
                placeholder="Enter the Last Name"
                inputValue={lastName || ""}
                setInputValue={setLastName}
              />
            </div>
          </section>

          <section className="flex flex-col md:flex-row md:space-x-4">
            <div className="w-full p-2 text-white">
              <TextInput
                title="Email Address"
                placeholder="Enter the email Address"
                inputValue={email || ""}
                setInputValue={setEmail}
              />
            </div>
            <div className="w-full p-2 text-white">
              <TextInput
                title="Phone Number"
                placeholder="Enter the phone number"
                inputValue={phoneNumber || ""}
                setInputValue={setPhoneNumber}
              />
            </div>
          </section>

          <Form.Item
            name="role"
            label="Role"
            rules={[{ required: true, message: "Please select a role!" }]}>
            <Select>
              <Option value="admin">Admin</Option>
              <Option value="super_admin">Super Admin</Option>
              <Option value="client">Client</Option>
            </Select>
          </Form.Item>
        </Form>
        {isProcessing && <ProgressSpinner />}
      </Modal>
    </div>
  );
};

export default ManageMembers;

